import { Skeleton } from '@mui/material';
import { useMemo } from 'react';
import { useQueries } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';

import items from '@/api/items';

const { getCategories } = items();

export default function Categories() {
	const dispatch = useDispatch();
	const client = useSelector((state) => state.auth.user?.client?.id);
	const categoryFilter = useSelector((state) => state.cart.categoryFilter);
	const selectedOutlet = useSelector((state) => state.auth.selectedOutlet);
	const accountType = useSelector((state) => state.auth.accountType);

	const outletId = selectedOutlet?.id ?? null;

	const queryResult = useQueries({
		queries: [
			{
				queryKey: ['item-categories', client, outletId],
				queryFn: () => getCategories({ client }),
				enabled: !!selectedOutlet && !!client,
				refetchOnWindowFocus: false,
			},
		],
	});

	const [a] = queryResult;
	const { data: categoryData } = a;

	const categories = useMemo(
		() => [{ id: 'x', name: 'All products' }].concat(categoryData?.data?.results || []),
		[categoryData]
	);

	const isLoaded = queryResult.every((query) => query.isSuccess);

	const onFilterItems = (id) => {
		dispatch({ type: 'cart/setCategoryFilter', payload: id });
	};

	const activeCategory =
		categoryFilter == null || categoryFilter === 'x' ? 'x' : categoryFilter;

	if (accountType === 'parent') {
		return (
			<div className='grid-filter' role='toolbar' aria-label='Product categories'>
				{!isLoaded && <Skeleton width={100} height={40} />}
				{isLoaded &&
					categories.map((f) => (
						<button
							key={f.id}
							type='button'
							className={activeCategory === f.id ? 'on' : undefined}
							aria-pressed={activeCategory === f.id}
							onClick={() => onFilterItems(f.id)}
						>
							{f.name}
						</button>
					))}
			</div>
		);
	}

	return (
		<div className='flex w-full gap-4'>
			{!isLoaded && (
				<div className='flex flex-1 w-full h-10 gap-4 overflow-hidden'>
					{[0, 1, 2, 3, 4, 5, 6, 7].map((a) => (
						<Skeleton key={a} className='w-full' />
					))}
				</div>
			)}
			{isLoaded &&
				categories.map((f) => (
					<button
						key={f.id}
						type='button'
						className={
							categoryFilter === f.id
								? 'px-4 py-2 rounded-sm bg-black text-white'
								: 'px-4 py-2 rounded-sm bg-white border border-black'
						}
						onClick={() => onFilterItems(f.id)}
					>
						{f.name}
					</button>
				))}
		</div>
	);
}
